/* ISO 3166-1 alpha-2 -> regional-indicator flag emoji. */
export const codeToFlagEmoji = (code) => {
  if (!code || !/^[A-Za-z]{2}$/.test(code)) return "🌐";
  const cc = code.toUpperCase();
  return String.fromCodePoint(...[...cc].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
};

export default codeToFlagEmoji;
